export const notesSelector = state => state.notes;
